<div class="additional-menu-items-container-component">
  <div *ngIf="htmlContent" [innerHTML]="htmlContent | safeHtml"></div>
  <iframe class="menu-item-frame" *ngIf="externalApplicationUrl" [src]="externalApplicationUrl"></iframe>
</div>
